<template>
    <el-row class="mg-b5">
        <el-card class="box-card">
            <div slot="header" class="clearfix" style="display: flex;justify-content: space-between;">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item class="my-form-item">
                        <el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
                            v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
                            style="width: 200px" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-input size="mini" placeholder="请输入送货单号查询" clearable v-model="quertInfo.objMap.xjdh"
                            style="width: 180px" prefix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-button size="mini" type="primary" @click="onSearch" >查询</el-button>
                    </el-form-item>
                </el-form>
                <div>
                    <el-button size="mini" v-if="checkRole('gys_role')" v-show="pageFlag=='all'|| pageFlag=='waita'"  type="primary" @click="addSendOrder"> 新增送货单 </el-button>
                </div>
            </div>
            <div class="order-table">
                <el-table :data="tableData" v-loading="loading" border size="mini" :header-cell-style="headerCellStyle" :height="count>0?PAGESIZE.h-290:PAGESIZE.h-258">
                    <el-table-column prop="orderState" label="送货单状态" :formatter="formatStatus"></el-table-column>
                    <el-table-column prop="deliverOrderCode" label="送货单号"></el-table-column>
                    <el-table-column prop="createTime" label="送货单日期"></el-table-column>
                    <el-table-column prop="xjOrderCode" label="收货客户"></el-table-column>
                    <el-table-column label="操作" align="left" width="150px" fixed="right">
                        <template slot-scope="scope">
                            <router-link :to="{path:`/planinfo/${scope.row.id}`}">送货单详情</router-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row type="flex" justify="end" class="mg-t5">
                    <pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
                        :limit.sync="quertInfo.limit" :total="count">
                    </pagination>
                </el-row>
            </div>
        </el-card>
        <EditSendOrder ref="EditSendOrderRef" />
    </el-row>
</template>

<script>
import { getShList } from '@/api/transport/index.js'
import EditSendOrder from './EditSendOrder'
export default {
    props: ['pageFlag'],
    components: {
        EditSendOrder,
    },
    data() {
        return {
            loading:false,
            tableData:[],
            count:0,
            quertInfo: {
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                searchTime: [],
                objMap: {
                    keyword: '',
                    // deliverState:1,		 // 0 待发布， 1 送货中 2待签收,
                }
            },
        };
    },
    computed: {
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
        currencyInfo:function(){
            return this.$store.getters['app/currencyInfo'];
        },
        userInfo:function(){
            return this.$store.getters['user/user'];
        },
    },
    created() {

    },
    methods: {
        getState(){
            let deliverState = '';
            if(this.checkRole('gys_role')){
                if(this.pageFlag == 'all'){
                    deliverState = '';
                }
                if(this.pageFlag == 'waita'){
                    deliverState = 0;
                }
                if(this.pageFlag == 'sending'){
                    deliverState = 1;
                }
                if(this.pageFlag == 'sendend'){
                    deliverState = 2;
                }
            }
            if(this.checkRole('cgy_role')){
                if(this.pageFlag == 'all'){
                    deliverState = '';
                }
                if(this.pageFlag == 'nosign'){
                    deliverState = 1;
                }
                if(this.pageFlag == 'issign'){
                    deliverState = 2;
                }
            }
            return deliverState
        },
        tableInit(){
            console.log('获取数据')
            console.log(this.pageFlag)
            this.tableData = [];
            this.count = 0;
            this.onSearch()
        },
        onSearch(){
            this.quertInfo.page = 1;
            this.getList();
        },
        async getList(){
            let _this = this;
            _this.loading = true;
            this.quertInfo.objMap['deliverState'] = this.getState();
            const { data: res } = await getShList(_this.quertInfo)
            _this.loading = false
            if (res.code == 0) {
                _this.tableData = res.data;
                _this.count = res.count;
            }
        },
        formatStatus(row){
            let text = '';
            if(this.checkRole('gys_role')){ // 供应商
                // deliverState:1,		 // 0 待发布， 1 送货中 2待签收,
                if(row.deliverState == 0){
                    text = '待发布'
                }
                if(row.deliverState == 1){
                    text = '送货中'
                }
                if(row.deliverState == 2){
                    text = '已签收'
                }
            }else{  // 采购员
                if(row.deliverState == 1){
                    text = '未签收'
                }
                if(row.deliverState == 2){
                    text = '已签收'
                }
            }
            return text
        },
        addSendOrder(){
            this.$refs.EditSendOrderRef.title="新增送货单";
            this.$refs.EditSendOrderRef.showForm=false;
            this.$refs.EditSendOrderRef.openDialog=true;
            this.$refs.EditSendOrderRef.getGoodsList();
        },
        onPagination: function(val) {
            this.quertInfo.page = val.page;
            this.quertInfo.limit = val.limit;
            this.getList();
        },
    },
    mounted() {

    },
    watch: {
        'pageFlag':function(nVal){
            this.tableData=[];
            this.count=0;
            this.quertInfo= {
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                searchTime: [],
                objMap: {
                    keyword: '',
                }
            };
            if(nVal){
                this.tableInit()
            }
        },
    },
};
</script>

<style lang="scss">

</style>
